import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FiCheck } from 'react-icons/fi';

import './style.css';

const Checkbox = ({ label, id, className, children, ...rest }) => {
  const customClassName = classNames('checkbox-control', className);
  return (
    <label htmlFor={id} className={customClassName}>
      <input id={id} type="checkbox" {...rest} />
      <FiCheck />
      <span>{label}</span>
    </label>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

Checkbox.defaultProps = {
  className: null,
  children: null,
};

export default Checkbox;
